import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart, Sparkle } from 'lucide-react';
import { usePricing } from '../hooks/usePricing';
export function HeroSection() {
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  const {
    formattedPrice,
    isLoading
  } = usePricing();
  const profilePhotos = ['https://cdn.magicpatterns.com/uploads/kS8Z5ZakRrv9TyS6pyQJor/d40244aa3f0ef852d37e20e7d8d6893d.jpg', 'https://cdn.magicpatterns.com/uploads/tq8AsaXoGdsFDCkraAj888/fotoag2015museo.jpg', 'https://cdn.magicpatterns.com/uploads/sMekjXofgHxYiK6qbtAQYq/images_(2)_3_11zon.jpg'];
  return <section className="relative pt-8 pb-12 md:pt-12 md:pb-20 overflow-hidden bg-warm-beige" data-id="element-136">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-copper/5 blur-3xl rounded-full -translate-y-1/2 translate-x-1/4" data-id="element-137" />
      <div className="absolute bottom-0 left-0 w-1/4 h-2/3 bg-copper/5 blur-3xl rounded-full translate-y-1/4 -translate-x-1/4" data-id="element-138" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-140">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-deep-brown leading-tight mb-6" data-id="element-141">
            Convierte a tu Mascota en un{' '}
            <span className="text-terracotta italic" data-id="element-142">Amigurumi Eterno</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 mb-0 leading-relaxed max-w-2xl mx-auto" data-id="element-143">
            No es solo un patrón. Es la oportunidad de tejer un recuerdo{' '}
            <span className="font-bold text-terracotta" data-id="element-144">
              idéntico a tu mejor amigo peludo
            </span>
            , capturando su esencia en cada puntada.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-3xl mx-auto mb-10" data-id="element-145">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white p-2 md:p-3" data-id="element-146">
            <div className="relative" data-id="element-147">
              <img src="https://cdn.magicpatterns.com/uploads/njYLEmLyW4kqydiKCQMP29/20260225_1747_Image_Generation_simple_compose_01kjb8vcmxecnb2ptf3s7evtje.png" alt="Bulldog Francés real junto a su versión amigurumi tejida a crochet" className="w-full rounded-xl" data-id="element-148" />
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-1.5 rounded-full text-xs font-bold text-deep-brown shadow-md" data-id="element-149">
                Tu Mascota
              </div>
              <div className="absolute bottom-4 right-4 bg-deep-brown/90 backdrop-blur-sm px-4 py-1.5 rounded-full text-xs font-bold text-white shadow-md flex items-center gap-1.5" data-id="element-150">
                Tu Creación{' '}
                <Heart size={11} fill="currentColor" className="text-copper" data-id="element-151" />
              </div>
            </div>
          </div>

          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 0.5
        }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl max-w-[200px] hidden md:block" data-id="element-152">
            <div className="flex items-center gap-2 mb-2" data-id="element-153">
              <div className="text-amber-400 flex text-sm" data-id="element-154">★★★★★</div>
            </div>
            <p className="text-xs text-gray-600 italic" data-id="element-155">
              "Lloré cuando terminé de tejer a mi Toby. Es idéntico."
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-center gap-5" data-id="element-156">
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="btn-pulse group relative px-10 py-4 bg-copper text-white rounded-full font-bold text-lg shadow-lg hover:shadow-xl hover:bg-copper/90 transition-all duration-300 flex items-center gap-2" data-id="element-157">
            Quiero mi ebook — {isLoading ? '...' : formattedPrice}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-158" />
          </a>

          <span className="text-copper font-medium text-sm tracking-wide flex items-center gap-1.5" data-id="element-159">
            <Sparkle size={14} className="text-terracotta" data-id="element-160" />
            Ebook Digital – Descarga Inmediata
          </span>

          <div className="flex items-center gap-2 text-sm text-warm-brown font-medium" data-id="element-161">
            <div className="flex -space-x-2" data-id="element-162">
              {profilePhotos.map((photo, i) => <img key={i} src={photo} alt={`Tejedora feliz ${i + 1}`} className="w-8 h-8 rounded-full object-cover border-2 border-white" data-id="element-163" />)}
            </div>
            <span data-id="element-164">+1,200 tejedoras felices</span>
          </div>
        </motion.div>
      </div>
    </section>;
}